declare global {
    interface String {
        visible(): any;

        hidden(): any;

        removeAtt(attName: string): any;

        setAtt(attName: string, attValue: string): any;

        setBg(colValue: string): any;

        setInnerHtml(text: string): string;

        isInnerHtml(text: string): boolean;
    }

    interface Number {
        toChatDate(): string;
    }
}

//don't redefine if it's already there
String.prototype.visible = function (): any {
    document.getElementById(this.toString())!.style.visibility = "visible";
};
String.prototype.hidden = function (): any {
    document.getElementById(this.toString())!.style.visibility = "hidden";
};
String.prototype.removeAtt = function (attName: string): any {
    document.getElementById(this.toString())!.removeAttribute(attName);
};
String.prototype.setAtt = function (attName: string, attValue: string): any {
    document.getElementById(this.toString())!.setAttribute(attName, attValue);
};

String.prototype.setBg = function (colValue: string): any {
    document.getElementById(this.toString())!.style.backgroundColor = `${colValue}`;
};
String.prototype.setInnerHtml = function (text: string): any {
    document.getElementById(this.toString())!.innerHTML = `${text}`;
};
String.prototype.isInnerHtml = function (text: string): boolean {
    return document.getElementById(this.toString())!.innerHTML === `${text}`;
};

Number.prototype.toChatDate = function (): string {
    const timeInMilliseconds = this.valueOf();
    const diff = new Date().getTime() - timeInMilliseconds;
    const calendar = new Date(timeInMilliseconds);

    if (diff < 24 * 60 * 60 * 1000 && calendar.getDay() === new Date().getDay()) return "Today";
    else if (
        diff < 2 * 24 * 60 * 60 * 1000 &&
        calendar.getDay() === new Date(Date.now() - 24 * 60 * 60 * 1000).getDay()
    )
        return "Yesterday";
    else if (diff < 6 * 24 * 60 * 60 * 1000)
        return new Intl.DateTimeFormat(navigator.language, { weekday: "long" }).format(calendar);
    else return calendar.toLocaleDateString();
};

export {};
